<div class="db-console" [class.dark]="isDark">
  
  <!-- ══════════════════════════════════════════════════════════════════════════
       WELCOME BANNER
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="db-welcome-banner">
          <!-- Power LED -->
          <div class="db-power-led"></div>
          
          <!-- Welcome Content -->
          <div class="db-welcome-content">
            <div class="db-welcome-icon">
              <fa-icon [icon]="faRocket"></fa-icon>
            </div>
            <div class="db-welcome-text">
              <span class="db-welcome-label">SYSTEM ONLINE</span>
              <h1 class="db-welcome-title">
                {{ 'ADMIN_DASHBOARD.WELCOME' | translate: { name: auth.getDisplayName(), role: auth.getDisplayRole() } }}
              </h1>
            </div>
          </div>

          <!-- Status Indicators -->
          <div class="db-status-indicators">
            <span class="db-led db-led--green"></span>
            <span class="db-led db-led--yellow"></span>
            <span class="db-led db-led--red"></span>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════════
         QUICK ACCESS CARDS
    ═══════════════════════════════════════════════════════════════════════════ -->
    <div class="row g-3 g-md-4">
      
      <!-- Users Card -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="db-card">
          <div class="db-card-header">
            <span class="db-card-led db-card-led--green"></span>
            <span class="db-card-led db-card-led--yellow"></span>
            <span class="db-card-led db-card-led--red"></span>
          </div>
          <div class="db-card-body">
            <div class="db-card-icon db-card-icon--blue">
              <fa-icon [icon]="faUsers"></fa-icon>
            </div>
            <div class="db-card-content">
              <span class="db-card-label">MODULE</span>
              <h3 class="db-card-title">Users</h3>
              <p class="db-card-desc">Manage user accounts and permissions</p>
            </div>
          </div>
          <div class="db-card-footer">
            <span class="db-card-status">READY</span>
          </div>
        </div>
      </div>

      <!-- Teams Card -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="db-card">
          <div class="db-card-header">
            <span class="db-card-led db-card-led--green"></span>
            <span class="db-card-led db-card-led--yellow"></span>
            <span class="db-card-led db-card-led--red"></span>
          </div>
          <div class="db-card-body">
            <div class="db-card-icon db-card-icon--purple">
              <fa-icon [icon]="faUsers"></fa-icon>
            </div>
            <div class="db-card-content">
              <span class="db-card-label">MODULE</span>
              <h3 class="db-card-title">Teams</h3>
              <p class="db-card-desc">Organize and manage team structures</p>
            </div>
          </div>
          <div class="db-card-footer">
            <span class="db-card-status">READY</span>
          </div>
        </div>
      </div>

      <!-- Analytics Card -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="db-card">
          <div class="db-card-header">
            <span class="db-card-led db-card-led--green"></span>
            <span class="db-card-led db-card-led--yellow"></span>
            <span class="db-card-led db-card-led--red"></span>
          </div>
          <div class="db-card-body">
            <div class="db-card-icon db-card-icon--cyan">
              <fa-icon [icon]="faChartLine"></fa-icon>
            </div>
            <div class="db-card-content">
              <span class="db-card-label">MODULE</span>
              <h3 class="db-card-title">Analytics</h3>
              <p class="db-card-desc">View reports and statistics</p>
            </div>
          </div>
          <div class="db-card-footer">
            <span class="db-card-status">READY</span>
          </div>
        </div>
      </div>

      <!-- Gamification Card -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="db-card">
          <div class="db-card-header">
            <span class="db-card-led db-card-led--green"></span>
            <span class="db-card-led db-card-led--yellow"></span>
            <span class="db-card-led db-card-led--red"></span>
          </div>
          <div class="db-card-body">
            <div class="db-card-icon db-card-icon--orange">
              <fa-icon [icon]="faTrophy"></fa-icon>
            </div>
            <div class="db-card-content">
              <span class="db-card-label">MODULE</span>
              <h3 class="db-card-title">Gamification</h3>
              <p class="db-card-desc">Achievements and rewards system</p>
            </div>
          </div>
          <div class="db-card-footer">
            <span class="db-card-status">READY</span>
          </div>
        </div>
      </div>

      <!-- Settings Card -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="db-card">
          <div class="db-card-header">
            <span class="db-card-led db-card-led--green"></span>
            <span class="db-card-led db-card-led--yellow"></span>
            <span class="db-card-led db-card-led--red"></span>
          </div>
          <div class="db-card-body">
            <div class="db-card-icon db-card-icon--green">
              <fa-icon [icon]="faCog"></fa-icon>
            </div>
            <div class="db-card-content">
              <span class="db-card-label">MODULE</span>
              <h3 class="db-card-title">Settings</h3>
              <p class="db-card-desc">Configure system preferences</p>
            </div>
          </div>
          <div class="db-card-footer">
            <span class="db-card-status">READY</span>
          </div>
        </div>
      </div>

      <!-- Console Card -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="db-card">
          <div class="db-card-header">
            <span class="db-card-led db-card-led--green"></span>
            <span class="db-card-led db-card-led--yellow"></span>
            <span class="db-card-led db-card-led--red"></span>
          </div>
          <div class="db-card-body">
            <div class="db-card-icon db-card-icon--red">
              <fa-icon [icon]="faGamepad"></fa-icon>
            </div>
            <div class="db-card-content">
              <span class="db-card-label">MODULE</span>
              <h3 class="db-card-title">Console</h3>
              <p class="db-card-desc">Advanced system controls</p>
            </div>
          </div>
          <div class="db-card-footer">
            <span class="db-card-status">READY</span>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>

